import { Component, ViewChild, OnInit } from '@angular/core';
import { ModelService } from 'src/app/services/model.service';
import { LoginService } from '../login_service/login.service';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/entities/user.entity';
import { Store } from '@ngrx/store';
import * as pathActions from '../../store/path/path.actions';
import { AppState } from '../../app.reducers';
import { UserListService } from 'src/app/admin/user-list/user-list.service';
import * as listUsersActions from '../../store/listUsers/listUsers.actions';
import { ListUsersFilters } from 'src/app/store/listUsers/listUsers.data';

@Component({
	selector: 'app-register',
	templateUrl: './registerinter.component.html',
	styleUrls: ['./registerinter.component.scss']
})
export class RegisterinterComponent implements OnInit {

	public registerData: User;
	public loading: boolean = false;
	public existsEmail = false;

	@ViewChild('registerForm', { static: false }) private registerForm;
	//@ViewChild('password1', { static: false }) private password1;
	//@ViewChild('password2', { static: false }) private password2;
	@ViewChild('email', { static: false }) private emailForm;

	// Store Redux
	private path = '';
	private _listOrder = {};
	private _listCurrentPage = 0;
	private _listItemsByPage = 10;
	private _listCurrentFilter = '1';

	constructor(
		private store: Store<AppState>,
		private loginService: LoginService,
		public modelService: ModelService,
		private userListService: UserListService,
		private router: Router) {
	}

	public ngOnInit() {
		this.registerData = new User();
		this.registerData.nombre = '';
		this.registerData.apellidos = '';
		if (this.registerForm) this.registerForm.reset();

		this.store.subscribe(state => {
			this.path = state.uiPath.path;
			this._listOrder = state.listUsers.order;
			this._listItemsByPage = state.listUsers.itemsByPage;
			this._listCurrentPage = state.listUsers.currentPage;
			this._listCurrentFilter = state.listUsers.currentFilter.toString();
		});
	}

	public register() {
		this.loading = true;

		this.registerData['idioma'] = this.modelService.getLanguage().currentLanguage;
		// Clonar los datos del formulario.
		let reg = JSON.parse(JSON.stringify(this.registerData));

		this.loginService.register(reg).subscribe(
			(data: any) => {
				console.log(data);
				if (data && data.ok === false) {
					this.existsEmail = true;
					this.emailForm.nativeElement.focus();
				}
				else {
					// Limpiar formulario.
					this.registerForm.reset();
					this.userListService.getCurrentList(this._listCurrentFilter, this._listOrder, this._listCurrentPage, this._listItemsByPage);
					this.router.navigate(['/user-list']);
				}
			},
			(error: Error) => { // this.alertService.error(error);
				setTimeout(() => this.loading = false, 1000);
			});
			this.loading = false;
	}
}
